import { Injectable } from "@angular/core";

@Injectable({ providedIn: "root" })
export class UtilsAssistanceService {
  constructor() {}

  hideSensitiveData(data: string) {
    if (!data) {
      return "";
    }
    const words = data.split(" ");
    const hiddenWords = words.map((word: any) => {
      if (word.length <= 3) {
        return word;
      } else {
        return word.substr(0, 1) + "*".repeat(word.length - 1);
      }
    });

    return hiddenWords.join(" ");
  }
}
